import {
  first_value,
  normalize_text,
  to_array,
  to_number,
} from './view_case_details_core_helpers';
import {
  form_sections,
  normalize_question_fact,
  section_title,
} from './view_case_details_answer_helpers';

function application_form_id_value(application_form = {}) {
  return application_form?.application_form_id || application_form?.applicationFormId || application_form?.id;
}

function application_form_form_id(application_form = {}) {
  return application_form?.form?.id || application_form?.form_id;
}

function section_key(application_form = {}, section = {}, title = '', index = 0) {
  const form_key = application_form_id_value(application_form) || 'form';
  const section_identifier = first_value([section?.id, section?.section_id, title, index]);
  return normalize_text(`${form_key}-${section_identifier}`);
}

function question_fact_context_for_section(application_form = {}, title = '') {
  return {
    application_form_id: application_form_id_value(application_form),
    form_id: application_form_form_id(application_form),
    section_title: title,
  };
}

function facts_from_section(application_form = {}, section = {}, title = '') {
  const context = question_fact_context_for_section(application_form, title);
  return to_array(section?.questions)
    .map((question) => normalize_question_fact(question, context))
    .filter(Boolean);
}

function case_fact_column_from_section(application_form = {}, section = {}, index = 0) {
  const title = section_title(section, index);
  return {
    title,
    section_key: section_key(application_form, section, title, index),
    application_form_id: to_number(application_form_id_value(application_form)),
    form_id: to_number(application_form_form_id(application_form)),
    items: facts_from_section(application_form, section, title),
  };
}

function case_fact_columns_from_sections(application_form = {}) {
  return form_sections(application_form)
    .map((section, index) => case_fact_column_from_section(application_form, section, index))
    .filter((column) => column.items.length);
}

function question_fact_context_for_form(application_form = {}) {
  return {
    application_form_id: application_form_id_value(application_form),
    form_id: application_form_form_id(application_form),
  };
}

function flat_facts_from_application_form(application_form = {}) {
  const form = application_form?.form || application_form || {};
  const context = question_fact_context_for_form(application_form);
  return to_array(form?.questions)
    .map((question) => normalize_question_fact(question, context));
}

function flat_facts_from_application_forms(application_forms = []) {
  return application_forms
    .flatMap(flat_facts_from_application_form)
    .filter(Boolean);
}

function fallback_columns_from_application_forms(application_forms = []) {
  const flat_facts = flat_facts_from_application_forms(application_forms);
  return flat_facts.length
    ? [{ title: 'Questions', section_key: 'questions', items: flat_facts }]
    : [];
}

export function case_fact_columns_from_application_forms(application_forms = []) {
  const columns = application_forms.flatMap(case_fact_columns_from_sections);
  return columns.length ? columns : fallback_columns_from_application_forms(application_forms);
}
